import React, { useState, useRef, Component, Fragment } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputKidsMulti from "../../helpers/InputKidsMulti";
import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDecimal from "../../helpers/InputDecimal";


import edit from "../../edit.png";
import trash from "../../trash.png";
import back from "../../back.png";
import FormatDecimal from "../../helpers/FormatDecimal";

import gopresent from "../../gopresent.png";


function TransferNew(props)
{ 

    const getDateYmd = () => {
        const dateObj = new Date();
        const month   = dateObj.getUTCMonth() + 1; // months from 1-12
        const day     = dateObj.getUTCDate();
        const year    = dateObj.getUTCFullYear();

       // const newDate = year + "/" + month + "/" + day;

        // Using template literals:
       // const newDate = `${year}/${month}/${day}`;

        // Using padded values, so that 2023/1/7 becomes 2023/01/07
        const pMonth        = month.toString().padStart(2,"0");
        const pDay          = day.toString().padStart(2,"0");
        const newPaddedDate = `${year}-${pMonth}-${pDay}`;

        return newPaddedDate;
}


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [subkonta, setSubkonta] = useState(null);  //


    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        dzieci: [],

        p_subkonta_id: '_x_',
        p_subkonta_id_valid: false,

        operacja_p: 'ma',
        operacja_p_valid: true,


       

        data: getDateYmd(),
        data_valid: true,


        tytul: 'Opłata za placówkę',
        tytul_valid: true,

        //laczna kwota do walidacji
        kwota: '',
        kwota_valid: false,

        typ_wplaty: 'przelew',
        typ_wplaty_valid: true,        

        pozycje: null,

        pokaz_w_rodzicow: 0,
       
    });


 
    const [kidReview, setKidReview] = useState(null);


    
    const onKidsSelected = (tab) => {
        setRow( {...row, ["dzieci"]: tab ,    ["pozycje"]:null,  ["p_subkonta_id"]:"_x_"  ,  ["p_subkonta_id_valid"]:false   } );

        if(tab.length > 0)
        {
            getKidReview(tab[0].id);
        }
    }



    const valChangeListener = (filedName, val, correct, msg) => { 
        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      


        if( (filedName == 'kwota'|| filedName == 'tytul' )   )
        {
             
                        if(subkonta.length == 2) //tylko jedno subkonto, pozycja pierwsza to '---'                        
                        {        
                            //chwilowo ukryte.. powodowalo zbyt duzo wywyłań..                   
                          // setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct, ["p_subkonta_id"]:subkonta[1].v, ["p_subkonta_id_valid"]:true,  ["pozycje"]:null   } );
                          // return;
                        }                      
            setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct, ["p_subkonta_id"]:'_x_',  ["pozycje"]:null   } );
            return;      
        }


        if(filedName == 'p_subkonta_id' || filedName == 'typ_wplaty' )
        {
            setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct,   ["pozycje"]:null   } );   //pozycje na null by pobrało ponownie
        
            return;
        }
 
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct  } );                 
    }



    const valChangeListener2 = (filedName, val, correct, msg) => { 
        
        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);   

       
        //var inxKey = rodzic.id + "@" + dziecko.id + "@" + poz.typ + "@" + poz.typ_id; 


        var sp = filedName.split("@");
        var rodzicId   = sp[0];
        var dzieckoId  = sp[1];
        var typ        = sp[2];
        var typId      = sp[3];

      //  console.log(rodzicId, dzieckoId, typ, typId);

    
 

 

        for(var r=0; r<row.pozycje.length; r++)
        {
            if(row.pozycje[r].id == rodzicId)
            {

                    for(var d=0; d < row.pozycje[r].dzieci.length; d++  )
                    {
                            if( row.pozycje[r].dzieci[d].id == dzieckoId )
                            {
                                    var dzieckoSum = 0;

                                    for(var z=0; z< row.pozycje[r].dzieci[d].zobowiazania.length; z++ )
                                    {
                                          if( row.pozycje[r].dzieci[d].zobowiazania[z].typ == typ &&  row.pozycje[r].dzieci[d].zobowiazania[z].typ_id == typId )
                                          {
                                            row.pozycje[r].dzieci[d].zobowiazania[z].sugerowana_kwota = val; 
                                          }

                                          //podliczaj..
                                          dzieckoSum = parseFloat(dzieckoSum) + parseFloat( row.pozycje[r].dzieci[d].zobowiazania[z].sugerowana_kwota  ) ;
                                    }

                                    row.pozycje[r].dzieci[d]["suma_sugerowana_kwota"] = dzieckoSum;
                            }
                    }
                   
            }
        }



        var ppp = JSON.parse(  JSON.stringify(row.pozycje) );

        setRow( {...row, ["pozycje"]:ppp  } );   

 
 
    }


 


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const onBack = (e) => {
        props.goBack();
    }


      const getSubkonta = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_calc,sb', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setSubkonta(res.result);                                                                                   
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const getKidReview = (kidId) => {

        
        var row = {
            p_dziecko_id: kidId,               
         }
         
         fetch( Config.url + '/rest_v1_rap,dz_info', {  
             method: 'POST', 
             body: JSON.stringify(row), 
             headers: {
                 'Content-Type': 'application/json',                    
                 'X-Api-Key': props.userData.apiKey,
                 '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                 '_p_dziecko_id_': props.userData.p_dziecko_id,
                 '_sec_key_': Config.genXKey() ,
             }
         })         
         .then(res => res.json() )
         .then(res => { 

                     

                     if(res._sys_ == undefined)
                     {
                         props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                     }else
                     if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                     {
                         props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                     }else    
                     {
                       
                         if(res.status == 'OK') {                                                          
                              setKidReview( res.result );
                         } 

                     }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                
         });

    }





    const saveData = (e) => {



        if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }


        if(row.dzieci.length < 1) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dziecka' ,  "ok"  ,null); 
                return; 
            }

 
        //sprawdz czy laczna kwota rowna sie sumie kwot czastkowych...


       
      
        
        var sumP = 0.00;

        for(var r=0; r<row.pozycje.length; r++)
        {
            for(var d=0; d<row.pozycje[r].dzieci.length; d++  )
            {
                for(var z=0; z<row.pozycje[r].dzieci[d].zobowiazania.length; z++ )
                {
                     var sk =  row.pozycje[r].dzieci[d].zobowiazania[z]['sugerowana_kwota'] ;  

                    if(sk == null)           continue;
                    if(sk == undefined)      continue;
                    if(sk.length < 1) continue;
                    
                    sumP =  parseFloat(  parseFloat(sk) + parseFloat(sumP)   ).toFixed(2);

                    console.log("SugKw", sk, sumP,   row.pozycje[r].dzieci[d].zobowiazania[z] );
                }
            }
        }

       
        var kL = parseFloat(row.kwota).toFixed(2);


        if(row.typ_wplaty == 'autoroz')
        {
            if(kL != sumP)
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Deklarowana kwota operacji nie jest równa sumie kwot cząstkowych. (' + kL + ' <> ' + sumP + ')' ,  "ok"  ,null); 
                    return; 
                }
        }else
        {
                if(kL != sumP)
                    {
                        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Deklarowana kwota operacji nie jest równa sumie kwot cząstkowych. (' + kL + ' <> ' + sumP + ')' ,  "ok"  ,null); 
                        return; 
                    }
        }

        

     

        props.mainView.setProgress(-2);

     
        var txtBtn = e.target.innerHTML;        
        e.target.innerHTML = "Czekaj....";


        var req = {

            p_dziecko_id: row.dzieci[0].id ,

            kwota: row.kwota,
            operacja_p:  row.operacja_p,
            p_subkonta_id:  row.p_subkonta_id,
            typ_wplaty:  row.typ_wplaty,
            data:  row.data,
            tytul:  row.tytul,

            pozycje: row.pozycje,
        };

    
        fetch( Config.url + '/rest_v1_calc,transfer_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    e.target.innerHTML = txtBtn;

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Dodano: ' + res.result, "ok" , null); 
                                props.goBack();
                        }else 
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }else 
                        {
                             props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }


    const getSaldoDet = (e) => {
 

        if(row.dzieci.length < 1)       return; 
        
      

        if(row.p_subkonta_id == '_x_')  return;
 

        props.mainView.setProgress(-2);

    
        fetch( Config.url + '/rest_v1_calc,actual_state', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                
                            setRow( {...row, ['pozycje']:res.result  } ); 

                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }




    if( row.pozycje == null && row.p_subkonta_id != '_x_' && row.dzieci.length > 0 )
    {    
        getSaldoDet();
    }

  


    const itemsTyp = [  
        { v: '_x_',   title: 'Wybierz' },            
        { v: 'gotówka', title: 'Gotówka' },        
        { v: 'przelew',   title: 'Przelew' },         
        { v: 'przelew_zus',  title: 'Przelew z ZUS' },                 
        { v: 'virtual',  title: 'Wirtualna (umorzona)' },                 
        { v: 'inne',  title: 'Inne, (wyrównanie salda, korekta, ...)' },                 
                  
    ]; 


    const itemsTypZ = [  
        { v: '_x_',   title: 'Wybierz' },            
        { v: 'gotówka', title: 'Gotówka' },        
        { v: 'przelew',   title: 'Przelew' },                               
        { v: 'inne',  title: 'Inne, (wyrównanie salda, korekta, ...)' },                 
        { v: 'autoroz',  title: 'Korekta salda bez roz. dokumentów' },                 
        { v: 'zwrot',  title: 'Zwrot części otrzymanego przelewu' },                 
    ]; 


    const itemsTypP = [    
      //  { v: '_x_',   title: 'Wybierz' },        
        { v: 'ma',   title: 'Wpłata / Nadpłata przeniesiona z innego systemu (MA)' },        
        { v: 'wn',   title: 'Zwrot do rodzica / Zaległość przeniesiona z innego systemu (WN)' },                         
    ]; 


    const itemsRodzic = [                
        { v: '0',   title: 'Pokaż tylko rodzica odpowiedzialnego za płatności' },        
        { v: '1',   title: 'Pokaż wszystkich rodziców' },                         
    ]; 


 
    if(subkonta == null)
    {
        setSubkonta([]);
        getSubkonta();
    }
   
     
    
    return <div className="view_content">

                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>

                    <h1>Nowa wpłata / zwrot</h1>


                    <form className="eForm bg_center">
                            <div className="form_tab_title">Wybierz jedno dziecko</div>
                            <div className="form_tab  " >               
                                        <InputKidsMulti   userData={props.userData}  mainView={props.mainView} onKidsSelected={onKidsSelected} max="1" />  
                            </div>

                            <div className="form_tab  " >    


                                                            {
                                                                    kidReview != null &&
                                                                    <Fragment>

                                                                                <div className="form_split"></div>

                                                                                <div className="form_control">                                                                                
                                                                                    <table>
                                                                                        {
                                                                                            kidReview.salda.map(  (info, sInx)  => {
                                                                                                return <tr>
                                                                                                    <td>{info.nazwa}</td>
                                                                                                    <td className="gobold goright"><FormatDecimal value={info.saldo} /></td>
                                                                                                </tr>
                                                                                            })
                                                                                        }
                                                                                    </table>
                                                                                </div>
                                                                                <br/>&nbsp; <br/>

                                                                                <div className="form_split"></div>
                                                                        
                                                                    </Fragment>
                                                                }

                            </div>


                            {
                                row.dzieci.length == 1 &&
                                <div>



                                                                  
                                                                     

                                                         

                                                                    <div className="form_control">

                                                                        <div className="fieldName">Kwota operacji</div>
                                                                       <InputDecimal   userData={props.userData} value={ row.kwota} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={  "kwota" } placeholder={"Kwota:"} className='w100' req='0'   />    
                                                                                                                                                                                       
                                                                    </div>



                                                                    <div className="form_control">
                                                                                <div className="fieldName">Data operacji </div>
                                                                                <InputDate   userData={props.userData} value={row.data} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data" placeholder={""} className=' ' req='1'   />
                                                                    </div>

                                                                    <div className="form_control">      
                                                                                                <div className="fieldName">Tytuł</div>
                                                                                                <InputText   userData={props.userData} value={row.tytul} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tytul" placeholder={"Tytuł: np. Wpłata za wrzesień, zwrot, ..."} className='w300' req='1'   />
                                                                    </div>


                                                                    <div className="form_split"></div>


                                                                    {
                                                                        row.kwota != 0 && row.tytul.length > 2 &&
                                                                        <React.Fragment>

                                                                                <div className="form_control">
                                                                                            <div className="fieldName">Konto</div>
                                                                                            <InputComboSubkonto  userData={props.userData} mainView={props.mainView}  value={row.p_subkonta_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={""} className='  ' req='1'   />                                    
                                                                                </div>


                                                                                <div className="form_split"></div>


                                                                                <div className="form_control">
                                                                                                    <div className="fieldName">Typ</div>
                                                                                                    <InputCombo items={itemsTypP} value={row.operacja_p} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="operacja_p" placeholder={""} className='  ' req='1'   />                                    
                                                                                </div>

                                                                        

                                                                                {
                                                                                    row.operacja_p == 'ma' &&
                                                                                    <Fragment>
                                                                                         <div className="form_control">
                                                                                                    <div className="fieldName">Operacja / Sposób rozliczenia</div>
                                                                                                    <InputCombo items={itemsTyp} value={row.typ_wplaty} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_wplaty" placeholder={""} className='  ' req='1'   />                                    
                                                                                        </div>
                                                                                    </Fragment>

                                                                                }
 
 {
                                                                                    row.operacja_p == 'wn' &&
                                                                                    <Fragment>
                                                                                         <div className="form_control">
                                                                                                    <div className="fieldName">Operacja / Sposób rozliczenia</div>
                                                                                                    <InputCombo items={itemsTypZ} value={row.typ_wplaty} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_wplaty" placeholder={""} className='  ' req='1'   />                                    
                                                                                        </div>
                                                                                    </Fragment>

                                                                                }

                                                                              
            

                                                                        </React.Fragment>
                                                                    }
                                                                     


                                        

                                                                    <div className="form_split"></div>
                                                            
                                                                            <div className="form_control">
                                                                                                    <div className="fieldName">Rodzice: </div>
                                                                                                    <InputCombo items={itemsRodzic} value={row.pokaz_w_rodzicow} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pokaz_w_rodzicow" placeholder={""} className='  ' req='1'   />                                    
                                                                                </div>

                                                                    <div className="form_split"></div>

                                                                    {
                                                                        row.p_subkonta_id != "_x_" &&
                                                                            <table className="table" >
                                                                            <thead>
                                                                                <tr className="header">                                                                                                                                                                                                                                                                   
                                                                                    <td>Rodzic</td>                                                                                                                                                                                                                                                                                                                                           
                                                                                    <td> &nbsp; </td>                                                                                                                                                                                                                                                                                                       
                                                                                </tr>
                                                                            </thead>

                                                                                    {
                                                                                        row.pozycje != null &&
                                                                                        <tbody>
                                                                                            
                                                                                            {

                                                                                        

                                                                                                row.pozycje.map( ( rodzic, inx) => {
                                                                                                    

                                                                                                    if(row.pokaz_w_rodzicow == 0 && rodzic.prowadzenie_salda  == 0 )
                                                                                                    {
                                                                                                         return null;
                                                                                                    } 

                                                                                                    var info = null;

                                                                                                    if(rodzic.prowadzenie_salda	 == 1)
                                                                                                    {
                                                                                                        info = <div>
                                                                                                            <strong>(Odpowiedzialny za płatności)</strong> 
                                                                                                            </div>
                                                                                                    }

                                                                                                    return <tr>
                                                                                                            <td className="gocenter">{rodzic.imie} {rodzic.nazwisko}, (Saldo: <FormatDecimal value={rodzic.saldo}/> ) {info}</td>                                                                 
                                                                                                            <td>
                                                                                                                    <table className="table" >
                                                                                                                        <thead>
                                                                                                                            
                                                                                                                        </thead>
                                                                                                                        <tbody>
                                                                                                                            {
                                                                                                                                rodzic.dzieci.map( (dziecko, dinx) => {


                                                                                                                                    var inxKeyTop = rodzic.id + "@" + dziecko.id + "@none@-1" ;

                                                                                                                                    var dzieckoKey = "razem#" + rodzic.id + "#" + dziecko.id ;


                                                                                                                                    return <tr>
                                                                                                                                                <td className="gocenter">{dziecko.imie} {dziecko.nazwisko} (Saldo: <FormatDecimal value={dziecko.saldo}/> )</td>                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                                                                                                <td>

                                                                                                                                                    <table className="table" >
                                                                                                                                                        <thead>
                                                                                                                                                            <tr className="header2">                                                                                                                                                                                                                                                                   
                                                                                                                                                                <td>
                                                                                                                                                                       {
                                                                                                                                                                        row.typ_wplaty == 'zwrot' &&
                                                                                                                                                                        <span>Przelew</span>
                                                                                                                                                                       }

                                                                                                                                                                       {
                                                                                                                                                                        row.typ_wplaty != 'zwrot' &&
                                                                                                                                                                        <span>Numer dok.</span>
                                                                                                                                                                       }
 
                                                                                                                                                                </td>                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                                                                                                                                <td>
                                                                                                                                                                {
                                                                                                                                                                        row.typ_wplaty == 'zwrot' &&
                                                                                                                                                                        <span>Możliwe do zwrotu</span>
                                                                                                                                                                       }

                                                                                                                                                                       {
                                                                                                                                                                        row.typ_wplaty != 'zwrot' &&
                                                                                                                                                                        <span>  Pozostało do zapł.</span>
                                                                                                                                                                       }
                                                                                                                                                                  
                                                                                                                                                                </td>                                                                                                                                                                                                                       
                                                                                                                                                                <td>Kwota operacji</td>                                                                                                                                                                                                                                                                                                       
                                                                                                                                                            </tr>
                                                                                                                                                        </thead>
                                                                                                                                                        <tbody>

                                                                                                                                                            {
                                                                                                                                                                dziecko.zobowiazania.map( (poz, inp) => {


                                                                                                                                                                var inxKey = rodzic.id + "@" + dziecko.id + "@" + poz.typ + "@" + poz.typ_id; 

                                                  
                                                                                                                                                                    return <tr>
                                                                                                                                                                        <td>{poz.opis}</td>                                                                                                                             
                                                                                                                                                                        <td className="goright">    <FormatDecimal value={poz.pozostalo} />    </td>
                                                                                                                                                                        <td className="gocenter">                                                                                                                                        
                                                                                                                                                                                
                                                                                                                                                                                 <InputDecimal   userData={props.userData} value={   poz.sugerowana_kwota } err={errTab}  valChange={valChangeListener2} goNext={goNextNew} name={  inxKey } placeholder={"Kwota:"} className='w100' req='0'   />    

                                                                                                                                                                        </td>
                                                                                                                                                                    </tr>
                                                                                                                                                                } )
                                                                                                                                                            }

                                                                                                                                                        

                                                                                                                                                            <tr>
                                                                                                                                                                <td className="gobold">Łączna kwota wpłaty / zwrotu</td>
                                                                                                                                                                <td> - </td>
                                                                                                                                                                <td className="gocenter gobold">
                                                                                                                                                                    <FormatDecimal value={ dziecko.suma_sugerowana_kwota }/> 
                                                                                                                                                                </td>
                                                                                                                                                            </tr>

                                                                                                                                                        </tbody>
                                                                                                                                                    </table>

                                                                                                                                                </td>  
                                                                                                                                    </tr>
                                                                                                                                } )
                                                                                                                            }
                                                                                                                        </tbody>
                                                                                                                    </table>
                                                                                                            </td>
                                                                                                    </tr>
                                                                                                }  )
                                                                                            }

                                                                                        </tbody>
                                                                                    }
                                                                            </table>
                                                                    }

                                                                  

                                                            


                                </div>
                            }


                            {
                                            row.kwota != 0 && row.tytul.length > 2 &&
                                            <React.Fragment>
                                                    <div className="form_split"></div>

                                                    <div className="form_btn">
                                                            <div className="btn" onClick={saveData}>Dodaj</div>
                                                            &nbsp;
                                                            <div className="btn" onClick={onBack}>Anuluj</div>
                                                    </div>
                                            </React.Fragment>
                            }    

                            

                    </form>



            </div>
}


export default TransferNew;
